<app-mat-spinner-overlay [overlay]="true" *ngIf="this.loading > 0">
</app-mat-spinner-overlay>

<div *ngIf="usuario && usuario.sucesso" class="panel panel-default bg-white-detail form-filtrar form-default PADRAO">
    <h3><strong>Detalhe da transação</strong></h3>

    <button type="button" mat-icon-button style="top: -10px; right: -10px; position: absolute;" matTooltip="Fechar" (click)="fechar()">
        <mat-icon aria-hidden="false" aria-label="Fechar" fontIcon="close">
        </mat-icon>
    </button>

    <div class="panel-body" [hidden]="ocultarDadosDetalhes">
        <mat-tab-group dynamicHeight>
            
            <mat-tab label="Transação">
                <div style="padding-top: 20px;">
                    <div class="row">
                        <div class="col-md-3 dados-detalhes-linha">
                            <div class="col-md-6 ">
                                <span class="dados-detalhes-label-transacao">Transação:</span><br />
                                <span class="dados-detalhes-codigo-transacao">{{ (dados.coD_TRANSACAO || dados.cod_transacao) }}</span>
                            </div>
                            <div class="col-md-6" *ngIf="dados.situacao == 'Efetuada'">
                                <span class="transacao-status transacao-aprovada">APROVADA</span>
                            </div>
                            <div class="col-md-6" *ngIf="dados.situacao == 'Rejeitada'">
                                <span class="transacao-status transacao-negada">NEGADA</span>
                            </div>
                        </div>
                        <div class="col-md-9" *ngIf="dados.situacao == 'Rejeitada'">
                            <span class="transacao-negada-descricao">{{ dados.coD_ERRO }} - {{dados.dsC_MENSAGEM_RETORNO}}</span>
                        </div>
                    </div>

                    <div class="row dados-linha-detalhes">
                        <div class="col-md-3 ">
                            <label>Placa</label>
                            <span class="dados-detalhes">{{ dados.dsC_PLACA }}</span>
                        </div>
                        <div class="col-md-6 ">
                            <label>Motorista</label>
                            <span class="dados-detalhes">{{ dados.dsC_NOME }}</span>
                        </div>
                        <div class="col-md-3 ">
                            <label>CPF</label>
                            <span class="dados-detalhes">{{ dados.nuM_CPF | cpfFormat}}</span>
                        </div>
                    </div>

                    <div class="row dados-linha-detalhes">
                        <div class="col-md-3 ">
                            <label>Data</label>
                            <span class="dados-detalhes">{{ dados.daT_ABASTECIMENTO | date: 'dd/MM/yyyy HH:mm:ss'}}</span>
                        </div>
                        <div class="col-md-3 ">
                            <label>Nº abastecimento</label>
                            <span class="dados-detalhes">{{ dados.coD_ABASTECIMENTO }}</span>
                        </div>
                        <div class="col-md-3 ">
                            <label>Pagamento</label>
                            <span class="dados-detalhes">{{ dados.dsC_TIPOPRODUTO }}</span>
                        </div>
                        <div class="col-md-3 ">
                            <label>Valor do abastecimento</label>
                            <span class="dados-detalhes">{{ dados.vlR_TOTAL | currency:'BRL':'symbol':'1.2-2' }}</span>
                        </div>
                    </div>

                    <div class="row dados-linha-detalhes">
                        <div class="col-md-3 ">
                            <label>Saldo atual</label>
                            <span class="dados-detalhes">{{ dados.vaL_SALDO }}</span>
                        </div>
                        <div class="col-md-3 ">
                            <label>Combustível</label>
                            <span class="dados-detalhes">{{ dados.zE_DESCRIC }}</span>
                        </div>
                        <div class="col-md-3 ">
                            <label>Litros</label>
                            <span class="dados-detalhes">{{ dados.qtD_VOLUME | number:'1.2-2' }}</span>
                        </div>
                        <div class="col-md-3 ">
                            <label>Valor litro</label>
                            <span class="dados-detalhes">{{ dados.vlR_UNITARIO_DESCONTO | currency:'BRL':'symbol':'1.2-2'}}</span>
                        </div>
                    </div>

                    <div class="row dados-linha-detalhes">
                        <div class="col-md-3 ">
                            <label>KM por litro</label>
                            <span class="dados-detalhes">{{ dados.kM_POR_LITRO | number:'1.2-2'}}</span>
                        </div>
                        <div class="col-md-3 ">
                            <label>Hodômetro digitado</label>
                            <span class="dados-detalhes">{{ dados.nuM_KM || getKmAtual(dados.status) }}</span>
                        </div>
                        <div class="col-md-3 ">
                            <label>Hodômetro anterior</label>
                            <span class="dados-detalhes">{{ getKmAnterior(dados.status) }}</span>
                        </div>
                        <div class="col-md-3 ">
                            <label>Litros por hora</label>
                            <span class="dados-detalhes"></span>
                        </div>
                    </div>
        <div class="row dados-linha-detalhes">
            <div class="col-md-3 ">

            </div>
                        <div class="col-md-3 ">
               <div
                    *ngIf="temImagemOdometro"
                    class="div-vertical-center-left"
                    style="max-height: 40px; cursor: pointer;"
                    (click)="verImagemTransacao()">

                    <img src="assets/icons/cam-ocr.svg"
                        alt="Ícone câmera"
                        style="width: 32px; height: 32px; margin-right: 8px;" />

                                <span class="camera-cor" style="font-weight: 500;text-decoration: underline;">Imagem do Hodômetro</span>
                            </div>
                        </div>
                        <div class="col-md-3 text-center">
                            <button type="button" class="btn btn-primary btn-submit btn-acao-ajustar-regra" [disabled]="byPass == false" (click)="chamarByPass()">
                                Bypass
                            </button>
                        </div>
                        <div class="col-md-3 text-center">
                            <button type="button" class="btn btn-primary btn-submit btn-acao-ajustar-regra" [disabled]="acaoRapida == false" (click)="chamarAjusteRegra()">
                                {{ textoBtnDetalhe == '' ? 'AJUSTAR REGRA' : textoBtnDetalhe }}
                            </button>
                        </div>
                    </div>
                </div>
            </mat-tab>

            <mat-tab label="Log de transação">
                <div style="padding: 15px; max-height: 550px; overflow-y: auto; background-color: #f4f4f4;">
                    
                    <h4 style="margin-top: 0; color: #333;"><strong>Detalhes da Autorização</strong></h4>
                    <div class="table-responsive" style="background-color: white; border-radius: 4px; box-shadow: 0 1px 3px rgba(0,0,0,0.1); margin-bottom: 20px;">
                        <table class="table table-condensed table-hover custom-log-table table-fixed">
                            <thead>
                                <tr style="background-color: #DDE1E6;">
                                    <th style="width: 10%;">Placa</th>
                                    <th style="width: 5%;">Vol</th>
                                    <th style="width: 8%;">Valor</th>
                                    <th style="width: 15%;">Data Processamento</th>
                                    <th style="width: 25%;">Dsc Sucesso</th>
                                    <th style="width: 15%;">Dsc Erro</th>
                                    <th style="width: 15%;">Status</th>
                                    <th style="width: 7%;">Retorno POS</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of dados.listaDetalheTransacao">
                                    <td>{{ item.dsC_PLACA }}</td>
                                    <td>{{ item.qtD_VOLUME | number:'1.2-2' }}</td>
                                    <td>{{ item.vlR_TOTAL | number:'1.2-2' }}</td>
                                    <td>{{ item.dT_PROCESSAMENTO | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                                    <td class="text-green text-wrap-cell">{{ item.dsC_SUCESSO }}</td>
                                    <td class="text-red text-wrap-cell">{{ item.dsC_ERRO }}</td>
                                    <td class="text-wrap-cell">{{ item.status }}</td>
                                    <td>{{ item.coD_RETORNO_POS }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <hr style="border-top: 2px solid #ddd; margin: 25px 0;">

                    <h4 style="color: #333;"><strong>Detalhes do Saldo</strong></h4>
                    <div class="table-responsive" style="background-color: white; border-radius: 4px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
                        <table class="table table-condensed table-hover custom-log-table">
                            <thead>
                                <tr style="background-color: #DDE1E6;">
                                    <th>Placa</th>
                                    <th>Vol</th>
                                    <th>Valor</th>
                                    <th>Data Processamento</th>
                                    <th>Saldo</th>
                                    <th>Vlr Unit</th>
                                    <th>Comb</th>
                                    <th>Cod Passo</th>
                                    <th>Inf</th>
                                    <th>Cap Tanque</th>
                                    <th>Nível Tanque</th>
                                    <th>Presset Abast</th>
                                    <th>Tipo Serviço</th>
                                    <th>Tipo Transação</th>
                                    <th>Dsc Proc</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let detalhe of dados.listaDetalheSaldo">
                                    <td>{{ detalhe.dsC_PLACA }}</td>
                                    <td>{{ detalhe.qtD_VOLUME | number:'1.2-2' }}</td>
                                    <td>{{ detalhe.vlR_TOTAL | number:'1.2-2' }}</td>
                                    <td>{{ detalhe.dT_PROCESSAMENTO | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                                    <td style="font-weight: bold;">{{ detalhe.vaL_SALDO | number:'1.2-2' }}</td>
                                    <td>{{ detalhe.vlR_UNITARIO | number:'1.2-2' }}</td>
                                    <td>{{ detalhe.zE_DESCRIC }}</td>
                                    <td>{{ detalhe.coD_PASSO }}</td>
                                    <td>{{ detalhe.dsC_INFO }}</td>
                                    <td>{{ detalhe.qtD_CAPTANQUE | number:'1.2-2' }}</td>
                                    <td>{{ detalhe.qtD_NIVEL_TANQUE | number:'1.2-2' }}</td>
                                    <td>{{ detalhe.qtD_PRESET_ABAST | number:'1.2-2' }}</td>
                                    <td>{{ detalhe.coD_TIPO_SERVICO }}</td>
                                    <td>{{ detalhe.coD_TIPO_TRANSACAO }}</td>
                                    <td class="text-wrap-cell">{{ detalhe.dsC_PROC }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </mat-tab>

            <mat-tab label="Comprovante">
                <div style="padding: 20px; max-height: 550px; overflow-y: auto; background-color: #fff;">
                    
                    <div class="comprovante-container" style="max-width: 600px; margin: 0 auto; color: #333;">
                        <h4 style="background-color: #e9ecef; padding: 5px 10px; font-size: 14px;"><strong>Comprovante</strong></h4>

                        <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;" *ngFor="let comprovante of dados.comprovante">
                            <tr>
                                <td style="width: 200px; padding: 4px;"><strong>Transação:</strong></td>
                                <td>{{ comprovante.coD_TRANSACAO }}</td>
                            </tr>
                            <tr>
                                <td style="padding: 4px;"><strong>Nº Cartão:</strong></td>
                                <td>{{ comprovante.nR_CARTAO }}</td>
                            </tr>
                            <tr>
                                <td style="padding: 4px;"><strong>Combustível Tipo:</strong></td>
                                <td>{{ comprovante.zE_DESCRIC }}</td>
                            </tr>
                            <tr>
                                <td style="padding: 4px;"><strong>Quantidade (Litros):</strong></td>
                                <td>{{ comprovante.biT_61_QUANTIDADE | number:'1.2-2' }}</td>
                            </tr>
                            <tr>
                                <td style="padding: 4px;"><strong>Odômetro:</strong></td>
                                <td>{{ comprovante.biT_61_ODOMETROVEICULO }}</td>
                            </tr>
                            <tr>
                                <td style="padding: 4px;"><strong>NSU Cancelamento:</strong></td>
                                <td>{{ comprovante.caNCELAMENTO_NSU }}</td>
                            </tr>
                            <tr>
                                <td style="padding: 4px;"><strong>Data Cancelamento:</strong></td>
                                <td>{{ comprovante.caNCELAMENTO_DATA }}</td>
                            </tr>
                            <tr>
                                <td style="padding: 4px;"><strong>Valor Cancelamento:</strong></td>
                                <td>{{ comprovante.caNCELAMENTO_VALOR | number:'1.2-2' }}</td>
                            </tr>
                            <tr>
                                <td style="padding: 4px; vertical-align: top;"><strong>Cód. de Autorização:</strong></td>
                                <td>
                                    {{ comprovante.biT_38_NSUDEAPROVACAO }}
                                </td>
                            </tr>
                            <tr>
                                <td style="padding: 4px; vertical-align: top;"><strong>Comprovante Impressão:</strong></td>
                                <td style="font-family: monospace; white-space: pre-wrap;">
                                    <div [innerHTML]="formatarComprovante(comprovante.comprovantE_RETORNO_IMPRESSAO)"></div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </mat-tab>

            <mat-tab label="Telemetria">
                <div style="padding: 20px; max-height: 550px; overflow-y: auto; background-color: #fff;">
                    <div class="col-md-3 ">
                        <strong>Telemetria</strong>
                        <span class="dados-detalhes mensagem-retorno">{{ (dados.dsC_MENSAGEM_RETORNO || '').trimStart().startsWith('Rastreador') ? dados.dsC_MENSAGEM_RETORNO : '' }}</span>
                    </div>
                </div>
            </mat-tab>

        </mat-tab-group>
    </div>

    <div [hidden]="!ocultarDadosDetalhes">
        <iframe [src]="url_redirect" width="100%" height="600" frameborder="0"></iframe>
    </div>
</div>

<!-- Dialog customizada para exibir imagem do hodômetro -->
<div
  class="custom-dialog-overlay"
  *ngIf="mostrarImagemTransacao"
  (click)="fecharImagemTransacao()"
>
  <div class="custom-dialog-content" (click)="$event.stopPropagation()">
    <h4>Imagem do Hodômetro</h4>
    <img
      *ngIf="imagemTransacao.retorno?.imG_BASE64"
      [src]="'data:image/jpeg;base64,' + imagemTransacao.retorno?.imG_BASE64"
      alt="Imagem do Hodômetro"
      style="max-width: 100%; max-height: 500px; object-fit: contain;"
    />
    <button style="margin-top: 20px;" type="button" class="btn btn-secondary" (click)="fecharImagemTransacao()">Fechar</button>
  </div>
</div>